import { Fragment, PropsWithChildren } from "react";
import { Control, Controller, FieldValues } from "react-hook-form";

import { FormControlLabel, FormGroup, Switch } from "@mui/material";

import { CommonFieldProps } from "./types";

interface Props<T extends FieldValues> extends CommonFieldProps<T> {
    control: Control<T, any>;
    label: string;
}

const FieldSwitch: React.FunctionComponent<Props<any>> = <TObject extends FieldValues>({
    control,
    fieldName,
    label,
    children,
}: PropsWithChildren<Props<TObject>>) => (
    <Fragment>
        <Controller
            control={control}
            name={fieldName}
            render={({ field: { value, ...field } }) => (
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch checked={!!value} {...field} color='secondary' />
                        }
                        label={label}
                    />
                </FormGroup>
            )}
        />
    </Fragment>
);

export default FieldSwitch;